module.exports = __webpack_public_path__ + "img/drop_down.5c9b25f4.svg";